import { render, staticRenderFns } from "./specifications.vue?vue&type=template&id=9e59d4b4&scoped=true"
import script from "./specifications.vue?vue&type=script&lang=js"
export * from "./specifications.vue?vue&type=script&lang=js"
import style0 from "./specifications.vue?vue&type=style&index=0&id=9e59d4b4&prod&lang=scss&scoped=true"
import style1 from "./specifications.vue?vue&type=style&index=1&id=9e59d4b4&prod&scoped=true&lang=scss"
import style2 from "./specifications.vue?vue&type=style&index=2&id=9e59d4b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e59d4b4",
  null
  
)

export default component.exports